<template>
  <div id="member-validation-container" class="container-24">
    <loading
      :show="showSpinner"
      label="Loading..."
      overlay="true">
    </loading>

    <div class="container">
      <div class="container member-validation-container">
        <div class="row member-validation-section">
          <section class="col-sm-12 member-validation-desc-header">
            <h2 class="title-24">Create new account</h2>
            <p>Setup online access to your membership account in two easy steps.</p>
            <h3 class="title-24">1. Validate Membership</h3>
          </section>
        </div>

        <div class="row member-validation-section" v-if="memberValidationError.length > 0">
          <section class="col-sm-12 member-validation-error alert alert-danger" role="alert" >
            <div>
              <a class="close" aria-label="close" title="close" v-on:click="memberValidationError = ''" >
                ×
              </a>
              <span>{{ memberValidationError }}</span>
            </div>
          </section>
        </div>

        <div class="row">
          <div class="col-md-6 col-xs-12">
            <member-validation-form
                :memberLoginUrl="memberLoginUrl"
                v-on:submitData="validateMember"
                v-on:openModal="openModal"
                :reEnableSubmitButton="reEnableSubmitButton">
            </member-validation-form>
          </div>
          <div class="col-md-6 col-xs-12 registration-form-image">
            <div class="card-img-container pull-right">
              <img src="../assets/sign_in.jpg" class="img img-responsive" alt="">
            </div>
          </div>
        </div>
      </div>

      <member-number-modal v-if="isModalOpen" v-on:closeModal="closeModal"></member-number-modal>

    </div>
  </div>
</template>

<script>
  import loading from '@/components/Loading.vue'
  import MemberValidationForm from '@/components/MemberValidationForm'
  import { memberValidationService } from '../services/ServiceContainer'
  import { mapGetters } from 'vuex'
  import MemberNumberModal from '@/components/MemberNumberModal'
  import cfg from '../services/configuration/PropertiesConfiguration'

  export default {
    name: 'member-validation',
    components: {
      loading,
      MemberValidationForm,
      MemberNumberModal
    },
    data () {
      return {
        isModalOpen: false,
        showSpinner: false,
        memberLoginUrl: cfg.memberLoginUrl,
        reEnableSubmitButton: false,
        memberValidationData: {
          memberIdentifier: '',
          birthDate: ''
        },
        memberValidationError: ''
      }
    },
    mounted () {
      this.showSpinner = true
      this.showSpinner = false
    },
    methods: {
      validateMember (data) {
        this.memberValidationData = data
        this.reEnableSubmitButton = false
        memberValidationService.validateMember({
          params: this.memberValidationData
        })
          .then((success) => {
            // Setting user input data in store
            this.$store.commit('setMemberValidationData', this.memberValidationData)
            // Setting member data in store
            this.$store.commit('setMemberData', this.buildDataObject(success.data))
            // Setting security questions in store
            this.$store.commit('setSecurityQuestionCatalog', success.data.securityQuestions)
            // Setting member validation status, so a user cannot be in step 2 without this
            this.$store.commit('setMemberValidationStatus', true)
            // Setting user email to store
            this.$store.commit('setEmailAddress', success.data.email)

            // redirecting user to step 2
            this.$router.push({name: 'CreateProfile'})
          }).catch((error) => {
            this.reEnableSubmitButton = true
            if (error.response !== undefined && error.response.data.errorMessage !== undefined) {
              this.memberValidationError = error.response.data.errorMessage
            } else {
              this.memberValidationError = 'There was an unexpected error when trying to validate the member'
            }
          })
      },

      buildDataObject (response) {
        const userData = {
          firstName: response.firstName,
          lastName: response.lastName,
          phone: response.phone,
          address: response.address,
          memberNumber: response.memberNumber
        }

        return userData
      },

      openModal () {
        this.isModalOpen = true
      },

      closeModal () {
        this.isModalOpen = false
      }
    },
    computed: {
      // Vuex helper to map computed properties for the desired stored getters
      ...mapGetters([
        'getIsMemberValidated',
        'getMemberData'
      ])
    }
  }
</script>

<style lang="scss">
  @import '~my-account-common-css/stylesheets/materialized.scss';
  @import '~bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss';
  @import '~my-account-common-css/stylesheets/container.scss';

  .member-validation-container {
    margin-bottom: 60px;
  }

  .card-img-container {
    margin-top: -24px;
  }

  .member-validation-error {
    margin: 20px 0px 50px 0px !important;
  }

  /* Medium devices (desktops, 992px and up) */
  @media (max-width: $screen-md-min) {
    .registration-form-image {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/MemberValidation.vue